/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.preload)();
	  (0, _module.anchorLink)();
	  (0, _module.toggleHeader)();
	  (0, _module.pageTop)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.errorImages = exports.pageTop = exports.showKV = exports.toggleHeader = exports.anchorLink = exports.preload = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width(); // preload
	
	var preload = function preload() {
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 77;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var toggleHeader = function toggleHeader() {
	  var headerFlag = false; // let stHeader  = document.getElementById('st-Header');
	
	  var stHeaderNav = document.getElementById('st-Header_Nav');
	  var headerButton = document.getElementById('st-Menu');
	  headerButton.addEventListener('click', function () {
	    if (!headerFlag) {
	      $('#st-Header_Nav').css({
	        'display': 'block'
	      });
	      setTimeout(function () {
	        // stHeader.classList.remove('closed');
	        stHeaderNav.classList.add('opend');
	        headerButton.classList.add('opend');
	        headerFlag = true;
	      }, 100);
	    } else {
	      stHeaderNav.classList.remove('opend');
	      headerButton.classList.remove('opend'); // stHeader.classList.add('closed');
	
	      headerFlag = false;
	      setTimeout(function () {
	        $('#st-Header_Nav').css({
	          'display': 'none'
	        });
	      }, 200);
	    }
	  }, false); // スクロールで縮める
	
	  $(window).on("scroll", function () {
	    var scrollPosition = $(window).scrollTop();
	
	    if (scrollPosition >= 33) {
	      $("#st-Header").addClass('st-Header-Shorten');
	    } else {
	      $("#st-Header").removeClass('st-Header-Shorten');
	    }
	  });
	}; // ------------------------------------------------------------------------
	// showKV
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleHeader = toggleHeader;
	
	var showKV = function showKV() {
	  //読み込みが完了
	  $(window).on('load', function () {
	    $('#index-Loading').stop().animate({
	      'opacity': 0
	    }, 1500, 'linear', function () {
	      $('#index-Loading').remove();
	    });
	  }); //load
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showKV = showKV;
	
	var pageTop = function pageTop() {
	  var PageTop = $("#st-Pagetop");
	  var Scroll = $("#index-Scroll");
	  var linkSpeed = 500;
	  $(window).on("scroll", function () {
	    var scrollPosition = $(window).scrollTop();
	
	    if (scrollPosition >= 50) {
	      PageTop.removeClass('st-Pagetop-Hidden');
	    } else {
	      PageTop.addClass('st-Pagetop-Hidden');
	    }
	  });
	  PageTop.on("click", function () {
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "easeInOutCubic");
	    return false;
	  });
	  Scroll.on("click", function () {
	    var indexH = $('#index-Mainvisual').height(); //下にスクロール
	
	    var windowH = $(window).height();
	    $("html, body").animate({
	      scrollTop: indexH + 40
	    }, linkSpeed, "easeInOutCubic");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// errorImages
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.pageTop = pageTop;
	
	var errorImages = function errorImages() {
	  var images = ['404_kaoru.jpg', '404_maya.jpg', '404_moca.jpg', '404_rinko.jpg', '404_tae.jpg'];
	  var randImg = images[Math.floor(Math.random() * images.length)];
	  var imagePath = path + '/assets/images/common/error/';
	  $('.randomImages').attr('src', imagePath + randImg);
	};
	
	exports.errorImages = errorImages;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common/app.bundle.js